'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defaults2 = require('lodash/defaults');

var _defaults3 = _interopRequireDefault(_defaults2);

var _forEach2 = require('lodash/forEach');

var _forEach3 = _interopRequireDefault(_forEach2);

exports.default = transpose;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transpose(props) {
    var series = props.series,
        seriesNormalized = props.seriesNormalized,
        minX = props.minX,
        maxY = props.maxY,
        minY = props.minY;


    var maxX = 0;
    var newSeries = [];
    (0, _forEach3.default)(series, function (series, seriesIndex) {
        (0, _forEach3.default)(series.data, function (point, pointIndex) {
            newSeries[pointIndex] = newSeries[pointIndex] || { data: [] };
            maxX = Math.max(maxX, seriesIndex);
            newSeries[pointIndex].data[seriesIndex] = (0, _defaults3.default)({
                realX: point.x,
                x: seriesIndex
            }, point);
        });
    });

    return {
        series: newSeries, seriesNormalized: seriesNormalized,
        maxX: maxX, maxY: maxY, minX: minX, minY: minY
    };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rumble-charts/lib/helpers/transforms/transpose.js
// module id = 1469
// module chunks = 0